export function TaskList({ title, uploadedFiles, submittedAt }) {
  return (
    <>
      <div className={`mt-2  border-[#DEDEDE] py-2 ${title==='Resubmitted Tasks'?'border-b-[0.5px]':'border-y-[0.5px]'}`}>
        <div className="flex  items-center justify-between ">
          <h2 className="py-2 font-semibold text-[#050505]">{title}</h2>
          <p className="text-[10px] font-medium text-[#939393]">
            {new Date(submittedAt).toLocaleString()}
          </p>
        </div>
        <ul>
          {uploadedFiles &&
            uploadedFiles.map((file) => (
              <li
                key={file.name}
                className="flex items-center justify-between "
              >
                <div>
                  <img
                    src="https://assets.learntube.ai/files/Content_player/Attachment_Paper.png?ik-sdk-version=javascript-1.4.3&updatedAt=1662805197601"
                    alt="icon"
                    className="inline-block"
                  />
                  <span className="ml-2 font-medium text-[#707070] ">
                    {file.name}
                  </span>
                </div>
                <a
                  href={file?.url}
                  download
                  className="ml-2 font-semibold text-[#29A4E9] underline"
                  target={'_blank'}
                  rel="noreferrer"
                >
                  View
                </a>
              </li>
            ))}
        </ul>
        {/* <p>{ submitTask?.}</p> */}
      </div>
    </>
  );
}
